import { useEffect, useState, useCallback } from "react";
import Styles from "./index.module.scss";
import { useLocation } from "react-router-dom";
import { CallApiGetNewById } from "../../../Api/Enforcement";
import clsx from "clsx";
import { Path } from "../../../Api/Path";
import MenuVTC from "../../../Share/Component/MenuVtc";

function NewDetail() {
  const location = useLocation();
  const pathnameArr = location.pathname.split("/:id");
  const ID = pathnameArr.pop();

  const handleCallApiNewByID = useCallback(() => {
    CallApiGetNewById(ID, (res) => {
      if ((res.Status = "success")) {
        const data = res.Response.data;
        setNewDetail(data);
      }
    });
  }, [ID]);

  const [newDetail, setNewDetail] = useState(null);
  useEffect(() => {
    handleCallApiNewByID();
  }, [handleCallApiNewByID]);

  function TextToHtml(text) {
    return (
      <div
        style={{ color: "#fff" }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: "#000" }}>
      <div className={clsx(Styles.wrapper)}>
        <div className={clsx(Styles.wrapperInner)}>
          <div className={clsx(Styles.contentMain)}>
            <div className={clsx(Styles.detailContent)}>
              {newDetail && (
                <>
                  <div className={clsx(Styles.head)}>
                    <h3 style={{ textAlign: "center" }}>{newDetail.Title}</h3>
                  </div>
                  <div className={clsx(Styles.body)}>
                    <img
                      alt="img"
                      className={clsx(Styles.img)}
                      src={Path.imageCDN + newDetail.Img}
                    />
                    {TextToHtml(newDetail.Description)}
                  </div>
                </>
              )}
              {/* <div className={clsx(Styles.iframe)}>
                <iframe
                  title="video"
                  className={clsx(Styles.responsiveIframe)}
                  src="https://www.youtube.com/embed/ZoLxWljG3RQ"
                ></iframe>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <MenuVTC />
    </div>
  );
}

export default NewDetail;
